var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPesquisaEInovacao(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_2133",
    "data-name": "Grupo 2133",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.258,
    height: 55.06,
    viewBox: "0 0 56.258 55.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1484",
    "data-name": "Ret\\xE2ngulo 1484",
    width: 56.258,
    height: 55.06,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2133-2",
    "data-name": "Grupo 2133",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1867",
    "data-name": "Caminho 1867",
    d: "M80.029,42.488l-3.561,4.656.977-.257L75.468,45.73a.715.715,0,0,0-.721,1.233l1.978,1.158a.736.736,0,0,0,.977-.256l3.561-4.656c.558-.73-.682-1.442-1.234-.721",
    transform: "translate(-49.488 -28.061)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1868",
    "data-name": "Caminho 1868",
    d: "M83.239,3.342V.69a.715.715,0,0,0-1.429,0V3.342a.715.715,0,0,0,1.429,0",
    transform: "translate(-54.415 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1869",
    "data-name": "Caminho 1869",
    d: "M37.735,47.418H35.083a.715.715,0,0,0,0,1.429h2.651a.715.715,0,0,0,0-1.429",
    transform: "translate(-22.876 -31.539)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1870",
    "data-name": "Caminho 1870",
    d: "M51.322,15.919l-1.875-1.875a.715.715,0,0,0-1.01,1.01l1.875,1.875a.715.715,0,0,0,1.01-1.01",
    transform: "translate(-32.077 -9.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1871",
    "data-name": "Caminho 1871",
    d: "M122.144,48.847H124.8a.715.715,0,0,0,0-1.429h-2.652a.715.715,0,0,0,0,1.429",
    transform: "translate(-80.783 -31.539)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1872",
    "data-name": "Caminho 1872",
    d: "M111.008,16.93l1.875-1.875a.715.715,0,0,0-1.01-1.01L110,15.92a.715.715,0,0,0,1.01,1.01",
    transform: "translate(-73.024 -9.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1873",
    "data-name": "Caminho 1873",
    d: "M74.016,29.758a10.082,10.082,0,1,0-18.14,6.056c.874,1.158,2.3,1.967,2.675,3.437a11.587,11.587,0,0,1,.112,2.444,3.959,3.959,0,0,0,4.109,3.864c1.654.016,3.553.262,4.941-.823a3.992,3.992,0,0,0,1.49-3.158c.03-1.178-.121-2.318.558-3.369a17.548,17.548,0,0,1,1.74-1.791,10.157,10.157,0,0,0,1.37-1.993,10.434,10.434,0,0,0,1.146-4.667.715.715,0,0,0-1.429,0,8.849,8.849,0,0,1-.882,3.813,11.739,11.739,0,0,1-2.5,3.08c-1.414,1.416-1.358,3.086-1.429,4.928a2.512,2.512,0,0,1-1.581,2.4,5.375,5.375,0,0,1-1.881.152c-1.613,0-3.634.165-4.145-1.83a9.024,9.024,0,0,1-.076-2.071,5.107,5.107,0,0,0-.949-3.007c-.641-.874-1.563-1.479-2.206-2.363a8.657,8.657,0,1,1,15.652-5.1.715.715,0,0,0,1.429,0",
    transform: "translate(-35.822 -13.088)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1874",
    "data-name": "Caminho 1874",
    d: "M68.968,79.062h9.111a.715.715,0,0,0,0-1.429H68.968a.715.715,0,0,0,0,1.429",
    transform: "translate(-45.414 -51.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1875",
    "data-name": "Caminho 1875",
    d: "M113.943,97.945c1.6-2.416,4.47-3.627,5.961-6.108.886-1.474,1.2-4.306-1.137-4.574-1.3-.15-2.343.806-3.3,1.548-1.273.99-2.547,1.95-3.9,2.834a17.1,17.1,0,0,1-3.913,1.88,5.481,5.481,0,0,0-3.074,2.061c-1.539,2.657-.323,5.869-1.124,8.676a.715.715,0,0,0,1.377.38,13.469,13.469,0,0,0,.322-4.351,7.558,7.558,0,0,1,.659-3.984c.755-1.226,2.594-1.453,3.814-1.967a22.289,22.289,0,0,0,3.9-2.292c1.3-.9,2.491-1.944,3.783-2.855.518-.366,1.534-.928,1.828-.025a2.331,2.331,0,0,1-.236,1.52c-.642,1.447-2.056,2.4-3.238,3.376a14.527,14.527,0,0,0-2.959,3.16c-.51.768.727,1.484,1.234.721",
    transform: "translate(-68.794 -58.031)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1876",
    "data-name": "Caminho 1876",
    d: "M130.072,89.5a5.966,5.966,0,0,1,2.078-3.556c1.163-.935,2.528-1.6,3.725-2.494A13.945,13.945,0,0,0,141,75.428a30.954,30.954,0,0,0,.639-10.84c-.132-1.183-.69-2.387-2.041-2.443s-2,1.121-2.309,2.271a17.358,17.358,0,0,0-.343,5.461,7.623,7.623,0,0,1-.9,2.791c-.338.855,1.042,1.226,1.377.38.239-.6.485-1.206.717-1.813.459-1.2.072-2.487.124-3.743.034-.825.12-3.464,1.026-3.865,1.216-.539,1.064,3.03,1.081,3.639a25.764,25.764,0,0,1-1.321,9.648,13.062,13.062,0,0,1-5.832,6.608c-2.26,1.412-3.921,2.893-4.518,5.6-.2.9,1.179,1.279,1.378.38",
    transform: "translate(-85.586 -41.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1877",
    "data-name": "Caminho 1877",
    d: "M108.1,140.131c-.2,1.08-.332,2.2-.6,3.261-.261,1.025-1.2.62-1.951.482l-8.132-1.5a6.379,6.379,0,0,1-2.1-.436c-.535-.353-.243-1.071-.153-1.562.129-.7.242-1.4.388-2.1.224-1.07.847-.928,1.7-.772l3.706.684,4.725.872c.808.149,2.508.126,2.4,1.261-.085.915,1.343.909,1.429,0,.147-1.575-1.071-2.2-2.375-2.44l-4.445-.82-4.826-.891c-1.124-.208-2.329-.531-3.187.5a3.72,3.72,0,0,0-.612,1.824c-.141.766-.3,1.531-.425,2.3a2.223,2.223,0,0,0,1.967,2.687c3,.58,6.016,1.11,9.023,1.665,1.2.222,2.65.739,3.654-.238a3.7,3.7,0,0,0,.786-2.158l.415-2.245c.166-.9-1.211-1.284-1.378-.38",
    transform: "translate(-62.251 -90.427)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1878",
    "data-name": "Caminho 1878",
    d: "M21.163,97.207a14.518,14.518,0,0,0-2.959-3.16c-1.18-.972-2.6-1.929-3.237-3.376a2.387,2.387,0,0,1-.253-1.406c.221-.921,1.111-.569,1.7-.192,1.375.876,2.577,2.034,3.925,2.959a22.665,22.665,0,0,0,3.749,2.228c1.259.545,3.186.765,3.964,2.03a7.547,7.547,0,0,1,.659,3.984,13.385,13.385,0,0,0,.321,4.351.715.715,0,0,0,1.378-.38c-.743-2.6.124-5.315-.791-7.914-.938-2.664-4.231-2.84-6.371-4.105a36.252,36.252,0,0,1-3.742-2.565c-1.04-.807-2.182-2.012-3.489-2.345-2.4-.613-3.161,1.922-2.437,3.73,1.193,2.977,4.614,4.273,6.348,6.883.506.762,1.744.048,1.233-.721",
    transform: "translate(-8.859 -58.014)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1879",
    "data-name": "Caminho 1879",
    d: "M13.111,89.129A7.822,7.822,0,0,0,9.4,84.036c-2.463-1.593-4.7-3.078-6.06-5.777a22.135,22.135,0,0,1-1.908-9.535q-.022-1.18.045-2.359a6.706,6.706,0,0,1,.267-2.354c.375-.771.967-.354,1.221.232A7.806,7.806,0,0,1,3.4,66.12a12.884,12.884,0,0,1,.127,2.763,5.36,5.36,0,0,0,.091,2.238c.222.654.511,1.291.765,1.934.334.845,1.717.477,1.378-.38C5.51,72.03,5.209,71.388,5,70.73a8.976,8.976,0,0,1-.011-2.711,15.02,15.02,0,0,0-.24-2.512c-.2-1.168-.484-2.768-1.753-3.231A2.028,2.028,0,0,0,.436,63.418,6.278,6.278,0,0,0,.1,65.526c-.061,1.006-.114,2.008-.1,3.017a33.224,33.224,0,0,0,.471,5.331,14.847,14.847,0,0,0,4.52,8.842c1.318,1.139,2.852,1.937,4.263,2.94a6.044,6.044,0,0,1,2.476,3.853c.2.9,1.576.518,1.378-.38",
    transform: "translate(0 -41.341)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1880",
    "data-name": "Caminho 1880",
    d: "M26.784,140.543a19.807,19.807,0,0,0,.722,3.677c.57,1.425,1.936,1.368,3.181,1.139l9.28-1.713c1.164-.215,2.384-.431,2.687-1.821a5.3,5.3,0,0,0-.207-1.977c-.132-.716-.23-1.447-.4-2.155-.346-1.467-1.59-1.871-2.928-1.624l-4.092.755-5.438,1c-1.418.262-3.007.664-2.833,2.525.085.907,1.514.917,1.429,0-.1-1.079,1.273-1.053,2.047-1.2l4.015-.741,4.141-.764c.767-.142,1.911-.643,2.264.331a8.328,8.328,0,0,1,.238,1.292,14.123,14.123,0,0,1,.357,1.936c.036.952-1.014.938-1.725,1.069l-8.044,1.485c-.814.15-2.323.792-2.7-.25a21.666,21.666,0,0,1-.618-3.351c-.167-.9-1.544-.52-1.378.38",
    transform: "translate(-17.79 -90.46)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPesquisaEInovacao);
export default __webpack_public_path__ + "static/media/pesquisa-e-inovacao.ccdf74e82fa47bd9e3dc71f161adfc14.svg";
export { ForwardRef as ReactComponent };